<template>
  <div class="menuBtn_wrapper">
    <el-tooltip
      v-for="(item, index) in btnList"
      :key="index"
      :content="item.tips"
      placement="top"
      :enterable="false"
    >
      <i
        :class="item.class"
        @click="handleClick(item)"
        style="margin-left:5px"
        :style="item.style"
      ></i>
    </el-tooltip>
    <!-- 复制版本 -->
    <el-dialog
      :title="isEdit ? '修改版本名称' : '复制'"
      :visible="showDialog"
      :modal="false"
      :show-close="false"
      width="350px"
      v-drag
    >
      <span class="label">名称：</span>
      <el-input style="width:85%" v-model="copyName"></el-input>
      <div slot="footer" class="dialog-footer">
        <ct-button size="small" :btn-click="closeModal">取消</ct-button>
        <ct-button size="small" type="primary" :btn-click="confirm"
          >确定</ct-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    state: {
      type: Number
    },
    isOwnerFlag: {
      type: Number
    },
    original: {
      type: Number
    },
    versionId: {
      type: Number
    },
    versionName: {
      type: String
    },
    refresh: {
      type: Function,
      default: function() {
        return function() {};
      }
    },
    towerId: {
      type: Number
    },
    menu: {
      type: Array,
      default: function() {
        return [];
      }
    },
    moduleType: {
      type: String
    }
  },
  data() {
    return {
      btnList: [],
      showDialog: false,
      copyName: '',
      dialogTitle: '复制',
      isEdit: false
    };
  },
  created() {
    this.getBtns();
  },
  watch: {
    menu: {
      handler(val) {
        if (val && val.length) this.getBtns();
      },
      deep: true
    }
  },
  methods: {
    handleClick(item) {
      let { type } = item;
      switch (type) {
        case 'copy':
          this.copyName = '';
          this.isEdit = false;
          this.openDialog();
          break;
        case 'edit':
          this.copyName = this.versionName;
          this.isEdit = true;
          this.openDialog();
          break;
        case 'delete':
          this.delete();
          break;
        case 'release':
          this.release();
          break;
        case 'cancle-release':
          this.cancelRelease();
      }
    },
    openDialog() {
      this.showDialog = true;
    },
    closeModal() {
      this.showDialog = false;
    },
    confirm() {
      this.closeModal();
      if (this.isEdit) {
        this.editConfirm();
      } else {
        this.getCopyConfirm();
      }
    },
    async getCopyConfirm() {
      let res = await this.$postForm('/winddata/dataProcess/copyTowerVersion', {
        module: 'windData',
        showError: true,
        data: {
          versionName: this.copyName,
          versionId: this.versionId
        }
      });
      if (res.code == 0) {
        this.refreshMenu();
      }
    },
    delete() {
      this.$confirm('确定删除测风塔版本吗?', '删除测风塔版本', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        cancelButtonClass: 'ct-btn-default',
        confirmButtonClass: 'ct-btn-primary',
        closeOnClickModal: false
      })
        .then(() => {
          this.$postForm('/winddata/dataProcess/delTowerVersion', {
            module: 'windData',
            showLoading: true,
            data: {
              towerId: this.towerId,
              versionId: this.versionId
            }
          }).then(() => {
            this.$message.success('删除成功!');
            sessionStorage.setItem('selectMenu', '');
            this.refreshMenu({ towerId: this.towerId });
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    refreshMenu(data) {
      this.$emit('refresh', data);
    },
    editConfirm() {
      this.$postForm('/winddata/dataProcess/updateTowerVersionName', {
        module: 'windData',
        data: {
          versionId: this.versionId,
          versionName: this.copyName
        }
      }).then(res => {
        if (res.code == 0) {
          this.refreshMenu();
        }
      });
    },
    release() {
      this.$confirm('是否覆盖之前发布的版本？', '发布', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      })
        .then(() => {
          this.$postForm('/winddata/dataProcess/releaseTowerVersion', {
            module: 'windData',
            showLoading: true,
            data: {
              towerId: this.towerId,
              versionId: this.versionId
            }
          }).then(res => {
            if (res.code === 0) {
              this.refreshMenu();
              this.$message.success(res.message);
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消发布'
          // });
        });
    },
    cancelRelease() {
      this.$confirm('确定取消发布吗？', '取消发布', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      })
        .then(() => {
          this.$postForm('/winddata/dataProcess/removeReleaseTowerVersion', {
            module: 'windData',
            showLoading: true,
            data: {
              towerId: this.towerId,
              versionId: this.versionId
            }
          }).then(res => {
            if (res.code === 0) {
              this.refreshMenu();
              this.$message.success('发布成功');
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    getBtns() {
      // moduleType === 'analysis' 代表风资源分析
      this.btnList =
        this.moduleType === 'analysis'
          ? []
          : [
              {
                type: 'copy',
                tips: '复制版本',
                class: 'iconfont iconfuzhi'
              }
            ];
      const releaseBtns = {
        0: {
          class: 'iconfont iconyifabu',
          tips: '其他人发布',
          style: {
            position: 'absolute',
            right: '190px',
            top: '3px',
            color: 'red'
          }
        },
        1: {
          class: 'iconfont iconyifabu',
          tips: '自己发布',
          style: {
            position: 'absolute',
            right: '190px',
            top: '3px',
            color: 'rgb(5,144,223)'
          }
        }
      };

      if (this.state == 1) {
        // 其他人发布
        this.btnList.push(releaseBtns[this.isOwnerFlag]);
        // 自己发布
        if (this.isOwnerFlag == 1) {
          // 风资源只显示已发布
          if (this.moduleType === 'analysis') {
            this.btnList = [releaseBtns[this.isOwnerFlag]];
            return;
          }
          this.btnList.push(releaseBtns[this.isOwnerFlag]);

          this.btnList.push({
            type: 'cancle-release',
            tips: '取消发布',
            class: 'iconfont iconquxiaofabu1'
          });
        }
      } else {
        // 发布
        if (this.moduleType === 'analysis') return;
        this.btnList.push({
          type: 'release',
          tips: '发布',
          // img: require('@/asset/wind-data/version-release.png')
          class: 'iconfont iconfabu'
        });
      }

      if (this.isOwnerFlag == 1 && this.original == 0) {
        this.btnList.push({
          type: 'edit',
          tips: '编辑',
          class: 'el-icon-edit-outline'
        });
        this.btnList.push({
          type: 'delete',
          tips: '删除',
          class: 'el-icon-delete'
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-footer {
  span:first-child {
    margin-right: 10px;
  }
}
.menuBtn {
  &_wrapper {
    position: absolute;
    right: 10px;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    height: 100%;
    img,
    i {
      font-size: 14px;
      display: inline-block;
      cursor: pointer;
      color: #fff;
    }
  }
}
</style>
